module.exports = __webpack_public_path__ + "static/media/BANANA-DOT-BNB.2aa0a20c.svg";